export default class ConversationMessageOriginModel {
  id!: number;

  name!: string;
}
